// import React, { useState , useEffect} from "react";
// import axios from "axios";
// import "../css/kycformnew.css";
// import { useDispatch, useSelector } from "react-redux";

// import { fetchEmployeeReport } from "../redux/slices/employeeReportSlice";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faCheck, faTimes, faTrash } from "@fortawesome/free-solid-svg-icons";

// export default function CustomerKyc() {
//     const dispatch = useDispatch();
//   const [filterType, setFilterType] = useState("customer id");
//   const [filterValue, setFilterValue] = useState("");
//   const [selectedEmployee, setSelectedEmployee] = useState("");
//   const [userDetails, setUserDetails] = useState(null);
//   const [uploadedKyc, setUploadedKyc] = useState([]);
//   const [previewImage, setPreviewImage] = useState(null);

//   const { list: data, loading, error, currentPage, totalPages } = useSelector(
//       (state) => state.employeeReport
//     );

//   // ------------------ Employee Dropdown (Static) ------------------
//   const employees = [
//     { id: "101", name: "Rahul Sharma" },
//     { id: "102", name: "Priya Verma" },
//     { id: "103", name: "Amit Singh" },
//     { id: "104", name: "Sneha Patel" },
//   ];

//   const pageSize = 100;

//     const fetchData = (page = 1) => {
//       dispatch(fetchEmployeeReport({ page, pageSize }));
//     };

//     useEffect(() => {
//       fetchData(1);
//     }, []);

//     const handlePreviewClick = (docImage) => {
//       if (!docImage) return;

//       const imageUrl = `https://payyug.in/uploads/${docImage}`;
//       setPreviewImage(imageUrl);
//     };

//   // ------------------ Search User ------------------
// const handleSearch = async () => {
//   if (!filterValue) {
//     alert("Please enter a value to search.");
//     return;
//   }
//   if (!selectedEmployee) {
//     alert("Please select an employee first.");
//     return;
//   }

//   const superAdminId = localStorage.getItem("adminuserId") || "14";
//   let query = { superAdminId, branchId: selectedEmployee };

//   if (filterType === "customer id") query.userId = filterValue.trim();
//   else if (filterType === "pan") query.panNumber = filterValue.trim();
//   else if (filterType === "aadhaar") query.aadhaarNumber = filterValue.trim();
//   else if (filterType === "mobile") query.mobileNumber = filterValue.trim();
//   else {
//     alert("This filter type is not supported for API search.");
//     return;
//   }

//   try {
//     const response = await axios.get(
//       "https://payyug.in/api/customers-get-userId",
//       { params: query }
//     );

//     const user = response.data.data;
//     if (user && user.userId) {
//       const details = {
//         userId: user.userId,
//         Id: user.id,
//         name: user.fullName,
//         pan: user.panNumber,
//         aadhaar: user.aadhaarNumber,
//         mobile: user.mobileNumber,
//         dob: user.dateOfBirth?.slice(0, 10),
//         superAdminId: user.superAdminId,
//         createdId: user.branchId, // ✅ save createdId for KYC filter
//       };
//       setUserDetails(details);

//       // ✅ Add createdId & superAdminId to KYC fetch
//       const kycResponse = await axios.get(`https://payyug.in/api/list-kyc`, {
//         params: {
//           userId: user.userId,
//           superAdminId: user.superAdminId,
//           createdId: user.branchId,
//         },
//       });

//       setUploadedKyc(kycResponse.data.documents || []);
//     } else {
//       setUserDetails(null);
//       setUploadedKyc([]);
//       alert("No user found.");
//     }
//   } catch (error) {
//     console.error("Error fetching user or KYC:", error);
//     alert("Failed to fetch user or KYC. Please try again.");
//   }
// };

//   // ------------------ Approve / Reject KYC ------------------
//   const handleAction = async (docId, action) => {
//     try {
//       const url =
//         action === "approved"
//           ? `https://payyug.in/api/approve-customer-kyc/${docId}`
//           : `https://payyug.in/api/reject-customer-kyc/${docId}`;

//       await axios.post(url);

//       alert(
//         action === "approved"
//           ? "✅ KYC Document Approved!"
//           : "❌ KYC Document Rejected!"
//       );

//       // Refresh documents
//       if (userDetails) {

//         console.log("userDetails");
//         console.log(userDetails);
//         console.log("userDetails");
//         const kycResponse = await axios.get(`https://payyug.in/api/list-kyc`, {
//            params: {
//           userId: userDetails.userId,
//           superAdminId: userDetails.superAdminId,
//           createdId: userDetails.createdId,
//         },
//         });
//         setUploadedKyc(kycResponse.data.documents || []);
//       }
//     } catch (error) {
//       console.error("Error updating KYC:", error);
//       alert("Failed to update KYC status. Please try again.");
//     }
//   };

// const handleDelete = async (docId) => {
//   if (!window.confirm("Are you sure you want to delete this document?")) return;

//   try {
//     const res = await fetch(`https://payyug.in/api/delete-customer-kyc/${docId}`, {
//       method: "DELETE",
//       headers: {
//         "Content-Type": "application/json",
//         // Add auth token if required
//         // Authorization: `Bearer ${token}`,
//       },
//     });

//     if (!res.ok) throw new Error("Failed to delete document");

//     // Remove deleted document from local state
//     setUploadedKyc(uploadedKyc.filter((doc) => doc.id !== docId));

//     alert("Document deleted successfully");
//   } catch (error) {
//     console.error(error);
//     alert("Error deleting document");
//   }
// };

//   // ------------------ JSX ------------------
//   return (
//     <div className="BranchLoanKycUpload-container">
//       <h1>Customer KYC Management</h1>

//       {/* Step 1 - Filter Section */}
//       <section className="BranchLoanKycUpload-section-filter">
//         <h2>1. Filter User</h2>
//         <div className="BranchLoanKycUpload-filter-row-wrapper">
//           <div className="BranchLoanKycUpload-filter-row">
//             {/* Employee Dropdown */}
//             <select
//               value={selectedEmployee}
//               onChange={(e) => setSelectedEmployee(e.target.value)}
//             >
//               <option value="">Select Employee</option>
//               {data.map((emp) => (
//                 <option key={emp.id} value={emp.id}>
//                   {emp.fullName}- {emp.id}
//                 </option>
//               ))}
//             </select>

//             {/* Filter Type Dropdown */}
//             {/* <select
//               value={filterType}
//               onChange={(e) => {
//                 setFilterType(e.target.value);
//                 setFilterValue("");
//               }}
//             >
//               <option value="">Select Filter Type</option>
//               <option value="customer id">Customer ID</option>
//               <option value="pan">PAN</option>
//               <option value="aadhaar">Aadhaar</option>
//               <option value="mobile">Mobile</option>
//             </select> */}

//             {/* Input Field */}
//             {/* {filterType && ( */}
//               <input
//                 type="text"
//                 placeholder={`Enter ${filterType}`}
//                 value={filterValue}
//                 onChange={(e) => setFilterValue(e.target.value)}
//               />
//             {/* )} */}
//           </div>
//         </div>
//         <button className="c-kyc-btn-search" onClick={handleSearch}>
//               🔍 Search
//          </button>
//       </section>

//       {/* Step 2 - User Details */}
//       {/* {userDetails && (
//         <section className="BranchLoanKycUpload-section">
//           <h2>2. User Details</h2>
//           <div className="table-wrapper">
//             <table className="BranchLoanKycUpload-user-details-table">
//               <tbody>
//                 <tr>
//                   <th>User ID</th>
//                   <td>{userDetails.userId}</td>
//                 </tr>
//                 <tr>
//                   <th>Name</th>
//                   <td>{userDetails.name}</td>
//                 </tr>
//                 <tr>
//                   <th>PAN</th>
//                   <td>{userDetails.pan}</td>
//                 </tr>
//                 <tr>
//                   <th>Customer ID</th>
//                   <td>{userDetails.Id}</td>
//                 </tr>
//                 <tr>
//                   <th>Aadhaar</th>
//                   <td>{userDetails.aadhaar}</td>
//                 </tr>
//                 <tr>
//                   <th>Mobile</th>
//                   <td>{userDetails.mobile}</td>
//                 </tr>
//                 <tr>
//                   <th>Date of Birth</th>
//                   <td>{userDetails.dob}</td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         </section>
//       )} */}

//       <section className="BranchLoanKycUpload-section">
//           <h2>2. User Details</h2>
//           <div className="table-wrapper">
//             {/* <table className="BranchLoanKycUpload-user-details-table">
//               <tbody>
//                 <tr>
//                   <th>User ID</th>
//                   <td>{userDetails?.userId}</td>
//                 </tr>
//                 <tr>
//                   <th>Name</th>
//                   <td>{userDetails?.name}</td>
//                 </tr>
//                 <tr>
//                   <th>PAN</th>
//                   <td>{userDetails?.pan}</td>
//                 </tr>
//                 <tr>
//                   <th>Customer ID</th>
//                   <td>{userDetails?.Id}</td>
//                 </tr>
//                 <tr>
//                   <th>Aadhaar</th>
//                   <td>{userDetails?.aadhaar}</td>
//                 </tr>
//                 <tr>
//                   <th>Mobile</th>
//                   <td>{userDetails?.mobile}</td>
//                 </tr>
//                 <tr>
//                   <th>Date of Birth</th>
//                   <td>{userDetails?.dob}</td>
//                 </tr>
//               </tbody>
//             </table> */}
//           </div>
//           <div className="customer-details-wrapper">
//              <div className="customerkyc-input-groups">
//                     <label>User Id</label>
//                     <input type="text" value={userDetails?.userId|| ""} readOnly />
//             </div>
//              <div className="customerkyc-input-groups">
//                     <label>Name</label>
//                     <input type="text" value={userDetails?.name|| ""} readOnly />
//             </div>
//              <div className="customerkyc-input-groups">
//                     <label>Pan Number</label>
//                     <input type="text" value={userDetails?.pan|| ""} readOnly />
//             </div>
//              <div className="customerkyc-input-groups">
//                     <label>Customer Id</label>
//                     <input type="text" value={userDetails?.Id|| ""} readOnly />
//             </div>
//              <div className="customerkyc-input-groups">
//                     <label>Aadhar Number</label>
//                     <input type="text" value={userDetails?.aadhaar|| ""} readOnly />
//             </div>
//              <div className="customerkyc-input-groups">
//                     <label>Mobile Number</label>
//                     <input type="text" value={userDetails?.mobile|| ""} readOnly />
//             </div>
//              <div className="customerkyc-input-groups">
//                     <label>Date of Birth</label>
//                     <input type="text" value={userDetails?.dob|| ""} readOnly />
//             </div>
//           </div>
//       </section>

//       <section className="BranchLoanKycUpload-section">
//         <h2>3. Customer KYC Document Details</h2>
//         <div className="table-wrapper">
//           <table className="BranchLoanKycUpload-table">
//             <thead>
//               <tr>
//                 <th>S.No</th>
//                 <th>Document Name</th>
//                 <th>Status</th>
//                 <th>Preview</th>
//                 <th>Action</th>
//                 <th>Delete</th>
//               </tr>
//             </thead>
//             <tbody>
//               {uploadedKyc.length > 0 ? (
//                 uploadedKyc.map((doc, idx) => (
//                   <tr key={doc.id}>
//                     <td>{idx + 1}</td>
//                     <td>{doc.docName||"N/A"}</td>
//                     <td>
//                       <span
//                         className={`status-badge ${
//                           doc.status === "pending"
//                             ? "approved"
//                             : doc.status === "rejected"
//                             ? "rejected"
//                             : "pending"
//                         }`}
//                       >
//                         {doc.status || "Pending"}
//                       </span>
//                     </td>
//                     <td>
//                       {doc.docImage ? (
//                         <button
//                           className="preview-link"
//                           onClick={() => handlePreviewClick(doc.docImage)}
//                           type="button"
//                         >
//                           Preview
//                         </button>
//                       ) : (
//                         "N/A"
//                       )}
//                     </td>

//                     <td>
//                      <button
//                         className="ckyc-btn-accept"
//                         onClick={() => handleAction(doc.id, "approved")}
//                         type="button"
//                         aria-label="Accept"
//                         title="Accept"
//                       >
//                         <FontAwesomeIcon icon={faCheck} />
//                       </button>

//                       <button
//                         className="ckyc-btn-reject"
//                         onClick={() => handleAction(doc.id, "rejected")}
//                         type="button"
//                         aria-label="Reject"
//                         title="Reject"
//                       >
//                         <FontAwesomeIcon icon={faTimes} />
//                       </button>
//                     </td>

//                       <td><button
//                         className="ckyc-btn-delete"
//                         title="Delete"
//                         onClick={() => handleDelete(doc.id)}
//                       >
//                         <FontAwesomeIcon icon={faTrash} />
//                       </button>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="5" style={{ textAlign: "center" }}>
//                     {userDetails
//                       ? "No documents found"
//                       : "Please search a user to view documents"}
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </section>

//        {/* 🔹 Preview Modal */}
//             {previewImage && (
//               <div className="modal-overlay" onClick={() => setPreviewImage(null)}>
//                 <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//                   <img src={previewImage} alt="KYC Preview" className="modal-image" />
//                   <button
//                     className="modal-close"
//                     onClick={() => setPreviewImage(null)}
//                   >
//                     X
//                   </button>
//                 </div>
//               </div>
//             )}
//     </div>
//   );
// }





import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select"; // 1. Import React Select
import "../css/kycformnew.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployeeReport } from "../redux/slices/employeeReportSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes, faTrash } from "@fortawesome/free-solid-svg-icons";

export default function CustomerKyc() {
  const dispatch = useDispatch();

  const [filterValue, setFilterValue] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState(null); // Changed to Object for React-Select
  const [userDetails, setUserDetails] = useState(null);
  const [uploadedKyc, setUploadedKyc] = useState([]);
  const [previewImage, setPreviewImage] = useState(null);
  const [customerByBranch, setCustomerByBranch] = useState([]);

  const { list: data } = useSelector((state) => state.employeeReport);

  useEffect(() => {
    dispatch(fetchEmployeeReport({ page: 1, pageSize: 100 }));
  }, [dispatch]);

  // Employee options formatting for react-select
  const employeeOptions = data
    ? data.map((emp) => ({
        value: emp.id,
        label: `${emp.fullName} - ${emp.id}`,
      }))
    : [];

  // Customer options formatting for react-select
  const customerOptions = customerByBranch.map((customer) => ({
    value: customer.userId,
    label: `${customer.fullName} - ${customer.userId}`,
  }));

  useEffect(() => {
    const fetchAllCustomersInBranch = async () => {
      if (!selectedEmployee) {
        setCustomerByBranch([]);
        setFilterValue(null); // ✅ Fixed: Use null instead of ""
        setUserDetails(null);
        setUploadedKyc([]);
        return;
      }

      // Jab naya employee select ho, tab purane customer ka data clear karein
      setFilterValue(null);
      setUserDetails(null);
      setUploadedKyc([]);

      try {
        const superAdminId = localStorage.getItem("adminuserId") || "14";
        const res = await axios.get("https://payyug.in/api/customers", {
          params: {
            superAdminId,
            branchId: selectedEmployee.value, // react-select ka .value use karein
            limit: 1000,
          },
        });
        setCustomerByBranch(res?.data?.data || []);
      } catch (err) {
        console.error("Error fetching branch customers:", err);
        setCustomerByBranch([]);
      }
    };
    fetchAllCustomersInBranch();
  }, [selectedEmployee]);

  const handleSearch = async () => {
    if (!filterValue) {
      alert("Please select a customer.");
      return;
    }

    try {
      const superAdminId = localStorage.getItem("adminuserId") || "14";
      const response = await axios.get(
        "https://payyug.in/api/customers-get-userId",
        {
          params: {
            superAdminId,
            branchId: selectedEmployee.value,
            userId: filterValue.value, // react-select object se value nikaali
          },
        },
      );

      const user = response.data.data;

      if (user) {
        setUserDetails({
          userId: user.userId,
          Id: user.id,
          name: user.fullName,
          pan: user.panNumber,
          aadhaar: user.aadhaarNumber,
          mobile: user.mobileNumber,
          dob: user.dateOfBirth?.slice(0, 10),
          superAdminId: user.superAdminId,
          createdId: user.branchId,
        });

        const kycResponse = await axios.get(`https://payyug.in/api/list-kyc`, {
          params: {
            userId: user.userId,
            superAdminId: user.superAdminId,
            createdId: user.branchId,
          },
        });
        setUploadedKyc(kycResponse.data.documents || []);
      } else {
        alert("Customer details not found.");
      }
    } catch (error) {
      console.error("Search Error:", error);
      alert("Failed to fetch customer detailed info.");
    }
  };

  // ... (handlePreviewClick, handleAction, handleDelete functions remain same)
  const handlePreviewClick = (docImage) => {
    if (!docImage) return;
    setPreviewImage(`https://payyug.in/uploads/${docImage}`);
  };

  const handleAction = async (docId, action) => {
    try {
      const url =
        action === "approved"
          ? `https://payyug.in/api/approve-customer-kyc/${docId}`
          : `https://payyug.in/api/reject-customer-kyc/${docId}`;
      await axios.post(url);
      alert(action === "approved" ? "✅ Approved!" : "❌ Rejected!");

      if (userDetails) {
        const res = await axios.get(`https://payyug.in/api/list-kyc`, {
          params: {
            userId: userDetails.userId,
            superAdminId: userDetails.superAdminId,
            createdId: userDetails.createdId,
          },
        });
        setUploadedKyc(res.data.documents || []);
      }
    } catch (error) {
      alert("Action failed.");
    }
  };

  const handleDelete = async (docId) => {
    if (!window.confirm("Are you sure?")) return;
    try {
      const res = await fetch(
        `https://payyug.in/api/delete-customer-kyc/${docId}`,
        { method: "DELETE" },
      );
      if (res.ok) {
        setUploadedKyc(uploadedKyc.filter((doc) => doc.id !== docId));
        alert("Deleted successfully");
      }
    } catch (error) {
      alert("Error deleting document");
    }
  };

  // React Select Custom Styles (Optional)
  const customStyles = {
    control: (base) => ({
      ...base,
      minWidth: "350px",
      // height:"40px",
      borderRadius: "4px",
      borderColor: "#ccc",
    }),
  };

  return (
    <div className="BranchLoanKycUpload-container">
      <h1>Customer KYC Management</h1>

      <section className="BranchLoanKycUpload-section-filter">
        <h2>1. Filter User</h2>
        <div className="BranchLoanKycUpload-filter-row-wrapper">
          <div className="BranchLoanKycUpload-filter-row">
            {/* 2. Employee Searchable Select */}
            <Select
              className="Select"
              options={employeeOptions}
              value={selectedEmployee}
              onChange={(option) => {
                setSelectedEmployee(option);
                setFilterValue(null); // Employee badalte hi customer select box reset ho jayega
                setUserDetails(null); // Input fields clear ho jayengi
                setUploadedKyc([]); // Table clear ho jayegi
              }}
              placeholder="Search Employee..."
              isSearchable
              // styles={customStyles}
            />

            {/* 3. Customer Searchable Select */}
            <Select
              className="Select"
              options={customerOptions}
              value={filterValue} // ✅ Yeh state se synced rehna chahiye
              onChange={(option) => setFilterValue(option)}
              placeholder="Search Customer..."
              isSearchable
              isDisabled={!selectedEmployee}
              // styles={customStyles}
            />
          </div>
        </div>
        <button
          className="c-kyc-btn-search"
          onClick={handleSearch}
          style={{ marginTop: "15px" }}
        >
          🔍 Search
        </button>
      </section>

      {/* 2. User Details Section */}
      <section className="BranchLoanKycUpload-section">
        <h2>2. User Details</h2>
        <div className="customer-details-wrapper">
          <div className="customerkyc-input-groups">
            <label>User Id</label>
            <input type="text" value={userDetails?.userId || ""} readOnly />
          </div>
          <div className="customerkyc-input-groups">
            <label>Name</label>
            <input type="text" value={userDetails?.name || ""} readOnly />
          </div>
          <div className="customerkyc-input-groups">
            <label>Pan Number</label>
            <input type="text" value={userDetails?.pan || ""} readOnly />
          </div>
          <div className="customerkyc-input-groups">
            <label>Customer Id</label>
            <input type="text" value={userDetails?.Id || ""} readOnly />
          </div>
          <div className="customerkyc-input-groups">
            <label>Aadhar Number</label>
            <input type="text" value={userDetails?.aadhaar || ""} readOnly />
          </div>
          <div className="customerkyc-input-groups">
            <label>Mobile Number</label>
            <input type="text" value={userDetails?.mobile || ""} readOnly />
          </div>
          <div className="customerkyc-input-groups">
            <label>Date of Birth</label>
            <input type="text" value={userDetails?.dob || ""} readOnly />
          </div>
        </div>
      </section>

      {/* 3. Document Table */}
      <section className="BranchLoanKycUpload-section">
        <h2>3. Customer KYC Document Details</h2>
        <div className="table-wrapper">
          <table className="BranchLoanKycUpload-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Document Name</th>
                <th>Status</th>
                <th>Preview</th>
                <th>Action</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {uploadedKyc.length > 0 ? (
                uploadedKyc.map((doc, idx) => (
                  <tr key={doc.id}>
                    <td>{idx + 1}</td>
                    <td>{doc.docName || "N/A"}</td>
                    <td>
                      <span
                        className={`status-badge ${doc.status ? doc.status.toLowerCase() : "pending"}`}
                      >
                        {doc.status || "Pending"}
                      </span>
                    </td>
                    <td>
                      {doc.docImage ? (
                        <button
                          className="preview-link"
                          onClick={() => handlePreviewClick(doc.docImage)}
                        >
                          Preview
                        </button>
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td>
                      <button
                        className="ckyc-btn-accept"
                        onClick={() => handleAction(doc.id, "approved")}
                        title="Approve"
                      >
                        <FontAwesomeIcon icon={faCheck} />
                      </button>
                      <button
                        className="ckyc-btn-reject"
                        onClick={() => handleAction(doc.id, "rejected")}
                        title="Reject"
                      >
                        <FontAwesomeIcon icon={faTimes} />
                      </button>
                    </td>
                    <td>
                      <button
                        className="ckyc-btn-delete"
                        onClick={() => handleDelete(doc.id)}
                        title="Delete"
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" style={{ textAlign: "center" }}>
                    {userDetails
                      ? "No documents found"
                      : "Please search a user to view documents"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>

      {/* Modal Preview */}
      {previewImage && (
        <div className="modal-overlay" onClick={() => setPreviewImage(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={previewImage} alt="KYC Preview" className="modal-image" />
            <button
              className="modal-close"
              onClick={() => setPreviewImage(null)}
            >
              X
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
